<div class="page-header-wrapper">
  <div [ngClass]="cssClass" class="page-header">
    @if (showBackButton || (showBackButtonOnMobileOnly && isMobileView)) {
      <div class="page-header__back-button">
        <app-icon [cssStyle]="{ marginBottom: '-2px' }" [routerLink]="backLink || '/'" [tippy]="'Back' | translate" cssClass="cursor-pointer" iconName="chevron-left" size="24px"></app-icon>
      </div>
    }

    @if (headerTitle && prefixIconName) {
      <div class="page-header__title-with-icon-prefix">
        <app-icon [color]="prefixIconColor" [iconName]="prefixIconName" [size]="prefixIconSize" marginBottom="-2px"></app-icon>
        <h1 [ngStyle]="headerTitleStyles">{{ headerTitle }}</h1>
      </div>
    }

    @if (headerTitle && !prefixIconName) {
      <h1 [ngStyle]="headerTitleStyles">{{ headerTitle }}</h1>
    }
    @if (breadcrumbs && breadcrumbs.length) {
      <div [ngStyle]="breadcrumbsStyles" class="page-header__bread-crumbs">
        @for (breadcrumb of breadcrumbs; track breadcrumb; let isLast = $last) {
          @if (breadcrumb.link) {
            <a [routerLink]="breadcrumb.link" class="cursor-pointer">{{ breadcrumb.label }}</a>
          }
          @if (!breadcrumb.link) {
            <span>{{ breadcrumb.label }}</span>
          }
          @if (!isLast) {
            <app-icon [cssStyle]="{ marginBottom: '-2px' }" iconName="chevron-right" size="18px"></app-icon>
          }
        }
      </div>
    }
  </div>
  @if (!titleOnly) {
    <div class="right-content">
      <!-- Content projection for right side content -->
      <ng-content></ng-content>
    </div>
  }
</div>
